var $5db1aa21a69c1057$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    //if (Cookies.get("notice") == undefined) {
    stepOne.showModal();
//}
//$("#stepOne").addClass("")
});
const $5db1aa21a69c1057$var$videoModal = document.getElementById("videoModal");
const $5db1aa21a69c1057$var$watchBtn = document.getElementById("watchBtn");
const $5db1aa21a69c1057$var$videoPlayer = document.getElementById("videoPlayer");
// Function to check if the dialog is open or closed
function $5db1aa21a69c1057$var$isDialogOpen(dialog) {
    return dialog.open;
}
//Function to handle changes in the dialog element
function $5db1aa21a69c1057$var$handleDialogChange(mutationsList) {
    for (const mutation of mutationsList)if (mutation.type === "attributes" && mutation.attributeName === "open") {
        const isOpen = $5db1aa21a69c1057$var$isDialogOpen(mutation.target);
        //console.log("Dialog is " + (isOpen ? "open" : "closed"));
        // Do something based on whether the dialog is open or closed
        if (isOpen) $5db1aa21a69c1057$var$videoPlayer.play();
        else $5db1aa21a69c1057$var$videoPlayer.pause();
    }
}
//Create a new MutationObserver
const $5db1aa21a69c1057$var$observer = new MutationObserver($5db1aa21a69c1057$var$handleDialogChange);
$5db1aa21a69c1057$var$observer.observe($5db1aa21a69c1057$var$videoModal, {
    attributes: true
});
// let dialog = document.querySelectorAll("dialog");
// dialog.forEach((el) =>
//   el.addEventListener("cancel", function (e) {
//     e.preventDefault();
//   }),
// );
const $5db1aa21a69c1057$var$dialogs = document.querySelectorAll("dialog");
function $5db1aa21a69c1057$var$cancelListener(e) {
    e.preventDefault();
}
$5db1aa21a69c1057$var$dialogs.forEach((dialog)=>{
    dialog.addEventListener("cancel", $5db1aa21a69c1057$var$cancelListener);
});
// When you no longer need the event listeners, remove them
// function removeEventListeners() {
//   dialogs.forEach(dialog => {
//     dialog.removeEventListener("cancel", cancelListener);
//   });
// }
$("#menu-toggle-btn").on("click", function() {
    //$("#toggleDrawer").click()
    //checkCheckboxStatus();
    //disableScroll();
    $("#toggleDrawer").trigger("click");
});
$("#nav li a").on("click", function() {
    //$("#toggleDrawer").click()
    //checkCheckboxStatus();
    //enableScroll();
    $("#toggleDrawer").trigger("click");
});
$("#close-menu").on("click", function() {
    //$("#toggleDrawer").click();
    //checkCheckboxStatus();
    $("#toggleDrawer").trigger("click");
});
$("#toggleDrawer").on("click", function() {
    $5db1aa21a69c1057$var$checkCheckboxStatus();
});
function $5db1aa21a69c1057$var$checkCheckboxStatus() {
    const checkbox = document.getElementById("toggleDrawer");
    const closeMenu = $("body.ltr #close-menu");
    const closeMenuAR = $("body.rtl #close-menu");
    if (checkbox.checked) {
        //console.log('Checkbox is checked');
        closeMenu.addClass("mr-[10vw] xl:mr-[17vw]");
        closeMenuAR.addClass("ml-[10vw] xl:ml-[17vw]");
    } else {
        //console.log('Checkbox is not checked');
        closeMenu.removeClass("mr-[10vw] xl:mr-[17vw]");
        closeMenuAR.removeClass("ml-[10vw] xl:ml-[17vw]");
    }
}
function $5db1aa21a69c1057$var$disableScroll() {
    // Save the current scroll position
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    // Add styles to disable scrolling
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
}
function $5db1aa21a69c1057$var$enableScroll() {
    // Restore the scroll position and remove styles
    const scrollPosition = parseInt(document.body.style.top, 10) || 0;
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    // Scroll back to the original position
    window.scrollTo(0, scrollPosition);
}
//disclaimer
// refresh scroll trigger
let $5db1aa21a69c1057$var$faqDiv = document.getElementById("faq-alpine");
let $5db1aa21a69c1057$var$faqitems = $5db1aa21a69c1057$var$faqDiv.querySelectorAll(".faq-item");
$5db1aa21a69c1057$var$faqitems.forEach((el)=>el.addEventListener("click", function(e) {
        setTimeout(function() {
            //console.log("clicked faq:" + new Date());
            ScrollTrigger.refresh();
        }, 400);
    })); // btnDynamic


//# sourceMappingURL=ar.f7546d40.js.map
